import type { ColoredOption } from './display';

// ── CRM / Appels d'offres (veille BOAMP) ──
/** Qualification d'un avis d'appel d'offres. */
export type TenderQualification = 'a_qualifier' | 'a_instruire' | 'suivi' | 'ecarte';
export const TENDER_QUALIFICATIONS: ColoredOption<TenderQualification>[] = [
  { key: 'a_qualifier', label: 'À qualifier', color: '#94A3B8' },
  { key: 'a_instruire', label: 'À instruire', color: '#D9A521' },
  { key: 'suivi', label: 'Suivi', color: '#3B82F6' },
  { key: 'ecarte', label: 'Écarté', color: '#94A3B8' },
];
export const TENDER_QUALIFICATION_MAP = Object.fromEntries(
  TENDER_QUALIFICATIONS.map((s) => [s.key, s]),
) as Record<TenderQualification, ColoredOption<TenderQualification>>;
// Motif d'écartement — distingue une ERREUR de tri (le score initial était faux, utile pour relire et
// affiner règles/prompt plus tard) d'une raison SANS RAPPORT avec la pertinence (capacité, priorité —
// l'AO était peut-être correctement identifié, on ne veut juste pas le traiter). Ne jamais mélanger
// les deux catégories dans une relecture de calibration, au risque de dégrader le tri sur de vrais
// positifs écartés faute de temps.
export const TENDER_SORTING_ERROR_REASONS = [
  'Ne concerne pas du développement',
  'Logiciel sur étagère / licence',
  'Maintenance de matériel physique',
  'Hors métier / secteur',
  'Stack technique non maîtrisée',
  'Autre erreur de tri',
];
export const TENDER_OTHER_REASONS = [
  'Pas le temps de traiter',
  'Montant trop faible',
  'Délai trop court pour répondre',
  'Zone géographique trop éloignée',
  'Client / secteur non souhaité',
  'Autre raison',
];
// Filtre par défaut de la vue Appels d'offres : masque "à instruire"/"écarté" (sortis du pipe actif)
// sans les exclure de la requête — cochable dans le filtre Statut pour les relire (motifs d'écartement).
export const TENDERS_FILTER_DEFAULT: {
  q: string;
  score: string[];
  statut: string[];
  montantMin: string;
  montantMax: string;
  avant: string;
} = {
  q: '',
  score: [],
  statut: ['a_qualifier', 'suivi'],
  montantMin: '',
  montantMax: '',
  avant: '',
};
/** Niveau de pertinence attribué à un avis d'appel d'offres. */
export type TenderScore =
  'fort' | 'moyen' | 'faible' | 'hors_delai' | 'non_pertinent' | 'non_classifie';
export const TENDER_SCORE_LEVELS: ColoredOption<TenderScore>[] = [
  { key: 'fort', label: 'Fort', color: '#1D9E75' },
  { key: 'moyen', label: 'Moyen', color: '#D9A521' },
  { key: 'faible', label: 'Faible', color: '#94A3B8' },
  { key: 'hors_delai', label: 'Hors délai', color: '#E24B4A' },
  { key: 'non_pertinent', label: 'Non pertinent', color: '#94A3B8' }, // n'apparaît normalement pas dans la liste (filtré), gardé pour l'affichage direct d'un avis
  { key: 'non_classifie', label: 'Non classé', color: '#94A3B8' }, // classification LLM jamais aboutie ; ne devrait plus être stocké depuis le correctif du 2026-09-03
];
export const TENDER_SCORE_MAP = Object.fromEntries(
  TENDER_SCORE_LEVELS.map((s) => [s.key, s]),
) as Record<TenderScore, ColoredOption<TenderScore>>;
/** Nombre d'avis affichés par page dans la liste des appels d'offres. */
export const TENDERS_PAGE_SIZE = 10;
